/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { MarginTypeResponse } from "../../../codegen-api";
import { Button, ButtonThemeEnum } from "../../Buttons/styles";
import { Chevron } from "../../shared/Chevron/style";
import { InputWrapper } from "../style";
import { LeverageModal } from "./LeverageModal";
import { MarginModal } from "./MarginModal";
import {
  CoreRing,
  InnerRing,
  LearnMoreText,
  MarginButton,
  MarginLabel,
  MarginSelectorWrapper,
  MarginTypeText,
  OuterRing,
  TopBtn,
} from "./style";
import {
  IMarginIconProps,
  IMarginSelectorProps,
  PerpFormFieldKeyEnum,
} from "./form.types";
import { useMarginSelector } from "./form.useMarginSelector";

export function MarginIcon({
  marginType = MarginTypeResponse.Isolated,
  isSelected,
}: IMarginIconProps) {
  return (
    <OuterRing isSelected={isSelected}>
      <InnerRing isIsolated={marginType === MarginTypeResponse.Isolated}>
        <CoreRing />
      </InnerRing>
    </OuterRing>
  );
}
export function MarginSelector({
  form,
  side,
  instrument,
  renderAsTopBar,
}: IMarginSelectorProps) {
  const {
    t,
    showLeverageModal,
    setShowLeverageModal,
    showMarginModal,
    onHideMarginModal,
    learnMoreMarginType,
    accountData,
    getMarginButtonStyle,
    marginType,
    displayLeverage,
    leverageUnavailableText,
    onUpdateMarginType,
    onUpdateLeverageSuccess,
    onLearnMore,
    isCross,
  } = useMarginSelector({ form, side, instrument });

  if (renderAsTopBar) {
    return (
      <>
        <LeverageModal
          show={showLeverageModal}
          onHide={() => setShowLeverageModal(false)}
          accountData={accountData}
          instrument={instrument}
          onUpdateLeverageSuccess={onUpdateLeverageSuccess}
          onLeverageUpdated={(value) => {
            form.setValue(PerpFormFieldKeyEnum.LEVERAGE, value.toFixed(2), {
              shouldDirty: true,
              shouldValidate: true,
            });
          }}
        />
        <MarginModal
          show={showMarginModal}
          onHide={onHideMarginModal}
          marginType={learnMoreMarginType as MarginTypeResponse}
        />
        {/* Margin type button — Cross / Isolated */}
        <TopBtn
          type="button"
          onClick={() => {
            const next = isCross
              ? MarginTypeResponse.Isolated
              : MarginTypeResponse.Cross;
            onUpdateMarginType(next);
          }}
        >
          {isCross ? t("cross") : t("isolated")}
        </TopBtn>
        {/* Leverage button */}
        <TopBtn
          data-trade-leverage
          type="button"
          title={leverageUnavailableText}
          aria-label={leverageUnavailableText}
          onClick={() => setShowLeverageModal(true)}
        >
          {displayLeverage ? `${displayLeverage}x` : "-"}
        </TopBtn>

      </>
    );
  }

  return (
    <>
      <LeverageModal
        show={showLeverageModal}
        onHide={() => setShowLeverageModal(false)}
        accountData={accountData}
        instrument={instrument}
        onUpdateLeverageSuccess={onUpdateLeverageSuccess}
        onLeverageUpdated={(value) => {
          form.setValue(PerpFormFieldKeyEnum.LEVERAGE, value.toFixed(2), {
            shouldDirty: true,
            shouldValidate: true,
          });
        }}
      />
      <MarginModal
        show={showMarginModal}
        onHide={onHideMarginModal}
        marginType={learnMoreMarginType as MarginTypeResponse}
      />
      <InputWrapper style={{ marginBottom: 0 }}>
        <MarginLabel>{t("margin_and_leverage_settings")}</MarginLabel>
        <MarginSelectorWrapper>
          <MarginButton
            isSelected={marginType?.toUpperCase() === MarginTypeResponse.Cross}
            onClick={() => onUpdateMarginType(MarginTypeResponse.Cross)}
            style={getMarginButtonStyle(MarginTypeResponse.Cross)}
            buttonTheme={ButtonThemeEnum.NEUTRAL2}
          >
            <MarginIcon
              isSelected={marginType?.toUpperCase() === MarginTypeResponse.Cross}
              marginType={MarginTypeResponse.Cross}
            />
            <MarginTypeText>
              <span>{t("cross")}</span>
              <LearnMoreText
                onClick={() => onLearnMore(MarginTypeResponse.Cross)}
              >
                {t("learn_more")}
              </LearnMoreText>
            </MarginTypeText>
          </MarginButton>
          <MarginButton
            isSelected={marginType?.toUpperCase() === MarginTypeResponse.Isolated}
            onClick={() => onUpdateMarginType(MarginTypeResponse.Isolated)}
            buttonTheme={ButtonThemeEnum.NEUTRAL2}
            style={{
              ...getMarginButtonStyle(MarginTypeResponse.Isolated),
              width: "100%",
            }}
          >
            <MarginIcon
              isSelected={
                marginType?.toUpperCase() === MarginTypeResponse.Isolated
              }
              marginType={MarginTypeResponse.Isolated}
            />
            <MarginTypeText>
              <span>{t("isolated")}</span>
              <LearnMoreText
                onClick={() => onLearnMore(MarginTypeResponse.Isolated)}
              >
                {t("learn_more")}
              </LearnMoreText>
            </MarginTypeText>
          </MarginButton>
          <Button
            buttonTheme={ButtonThemeEnum.NEUTRAL2}
            title={leverageUnavailableText}
            aria-label={leverageUnavailableText}
            onClick={() => setShowLeverageModal(true)}
          >
            {displayLeverage ? `${displayLeverage}x` : "-"}
            {accountData ? <Chevron size="small" direction={"down"} /> : null}
          </Button>
        </MarginSelectorWrapper>
      </InputWrapper>
    </>
  );
}
